import React from "react";
import { Link, useParams } from "react-router-dom";
import { useData } from "@/context/DataContext";
import Seo from "@/components/site/Seo";
import { PageHero } from "@/components/site/Layout";
import { Reveal } from "@/components/site/Reveal";
import { GuideCard, GuideCta } from "@/components/site/GuideBits";

export default function GuideCategory() {
  const { slug } = useParams();
  const { guides, guideCategories } = useData();
  const cat = guideCategories.find((c) => c.slug === slug);
  const list = guides.filter((g) => g.categoria === slug);

  if (!cat) {
    return (
      <div className="min-h-[60vh] bg-av-black flex flex-col items-center justify-center px-6 text-center">
        <h1 className="font-display text-4xl text-av-white">Categoria non trovata</h1>
        <Link to="/guide" className="mt-6 text-av-lime">← Torna alle guide</Link>
      </div>
    );
  }

  return (
    <>
      <Seo title={`${cat.nome} — Guide`} description={cat.descrizione} path={`/guide/categoria/${cat.slug}`} />
      <PageHero
        overline="Centro Guide"
        title={cat.nome}
        subtitle={cat.descrizione}
        breadcrumb={<><Link to="/" className="hover:text-av-lime">Home</Link> / <Link to="/guide" className="hover:text-av-lime">Guide</Link> / <span className="text-av-white">{cat.nome}</span></>}
      />
      <section className="bg-av-black py-14 sm:py-20">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
          {list.length > 0 ? (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {list.map((g, i) => <Reveal key={g.id} delay={(i % 3) * 0.06}><GuideCard g={g} /></Reveal>)}
            </div>
          ) : (
            <p className="text-av-gray">Le guide di questa categoria saranno presto disponibili. Nel frattempo puoi <Link to="/chiedi-all-esperto" className="text-av-lime underline">chiedere all'esperto</Link> o contattarci.</p>
          )}
          <GuideCta />
        </div>
      </section>
    </>
  );
}
